import { render } from "./ListByBrandHeader.vue?vue&type=template&id=7f008c96"
import script from "./ListByBrandHeader.vue?vue&type=script&lang=js"
export * from "./ListByBrandHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/learnbody/Documents/VSWorkspaces/learnbody-market-v1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__